module.exports = __webpack_public_path__ + "img/HiMart.7063e3e.png";